// This is where all the node_modules needed are put so webpack can create a vendor file
// import 'react';
// import 'react-dom';
import './styles/main.scss';
import 'travco-header/dist/style.css';
import 'travco-footer/dist/style.css';
import 'travco-modal/dist/style.css';
import 'travco-date-range-picker/dist/style.css';
import 'travco-masterdata-autocomplete/dist/style.css';
import 'travco-input-number/dist/style.css';
import 'travco-accordion/dist/style.css';
import 'travco-loading-spinner/dist/style.css';
import 'react-input-range/lib/css/index.css';
import 'react-tippy/dist/tippy.css';
import 'travco-common-styles/dist/style.css';
import 'travco-hotel-autocomplete/dist/style.css';
